(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geeta-flash-sale"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geeta-tickets-section"] && !Shopify.designMode) return;
  try {
    
// Issue type mapping
const issueTypes = {
    "Before You Buy": [
        "Product Details",
        "Wig Features & Styles",
        "Sales Promotion"
    ],
    "Order & Payments": [
        "Order Issues & Adjustments",
        "Payment Issues",
        "Tax Issues"
    ],
    "Track & Shipping": [
        "Shipping & Delivery",
        "Tracking Order",
        "Missing Package",
        "Damaged Package"
    ],
    "After-sales Support": [
        "Wig Usage & Installation",
        "Wig Maintenance & Care",
        "Return & Refund"
    ],
    "VIP & Account": [
        "VIP Rewards",
        "Account Management"
    ],
    "Refer & Earn": [
        "Refer & Earn"
    ],
    "Frequently asked questions": [
        "General Questions"
    ]
};

// Order-related categories
const orderRelatedCategories = [
    "Order & Payments",
    "Track & Shipping",
    "After-sales Support"
];

// Get Worker URL from hidden field
const workerUrl = document.getElementById('workerUrlField').value;

// Add debugging info
console.log('Worker URL configured as:', workerUrl);

// Validate workerUrl immediately
if (!workerUrl || workerUrl === '' || workerUrl === '{{ section.settings.worker_url }}') {
    console.error('Error: Worker URL is not configured properly. Please set the Worker URL in the section settings.');
    alert('Error: Worker URL is not configured. Please contact support.');
}

// Global variables
let uploadedFiles = [];
let selectedOrder = null;

// Initialize form
function initForm() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const emailInput = document.getElementById('email');
    const fileUpload = document.getElementById('fileUpload');
    const fileInput = document.getElementById('fileInput');
    const form = document.getElementById('ticketForm');

    // Issue category change handler
    categorySelect.addEventListener('change', handleCategoryChange);
    
    // Email change handler for order lookup
    emailInput.addEventListener('change', handleEmailChange);
    
    // File upload handlers
    fileUpload.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', handleFileSelect);
    fileUpload.addEventListener('dragover', handleDragOver);
    fileUpload.addEventListener('drop', handleDrop);
    
    // Form submission handler
    form.addEventListener('submit', handleFormSubmit);
}

// Handle issue category change
function handleCategoryChange() {
    const categorySelect = document.getElementById('issueCategory');
    const subcategorySelect = document.getElementById('issueSubcategory');
    const selectedCategory = categorySelect.value;
    
    console.log('Category changed to:', selectedCategory);
    console.log('issueTypes object:', issueTypes);
    console.log('Issue types keys:', Object.keys(issueTypes));
    
    // Clear existing options
    subcategorySelect.innerHTML = '<option value="">Select Subcategory</option>';
    
    // Populate subcategories
    if (selectedCategory && issueTypes[selectedCategory]) {
        console.log('Found subcategories:', issueTypes[selectedCategory]);
        issueTypes[selectedCategory].forEach(subcategory => {
            const option = document.createElement('option');
            option.value = subcategory;
            option.textContent = subcategory;
            subcategorySelect.appendChild(option);
        });
    } else {
        console.error('No subcategories found for category:', selectedCategory);
    }
    
    // Show/hide order section based on category
    const orderSection = document.getElementById('orderSection');
    if (orderRelatedCategories.includes(selectedCategory)) {
        orderSection.style.display = 'block';
        // Trigger order lookup if email is provided
        const email = document.getElementById('email').value;
        if (email) {
            lookupOrders(email);
        }
    } else {
        orderSection.style.display = 'none';
        selectedOrder = null;
        document.getElementById('selectedOrder').value = '';
        document.getElementById('orderList').innerHTML = '';
    }
}

// Handle email change for order lookup
function handleEmailChange() {
    const email = this.value;
    const categorySelect = document.getElementById('issueCategory');
    const selectedCategory = categorySelect.value;
    
    console.log('Email changed to:', email);
    console.log('Current category:', selectedCategory);
    console.log('Order-related categories:', orderRelatedCategories);
    
    // Only lookup orders if category is order-related
    if (email && orderRelatedCategories.includes(selectedCategory)) {
        console.log('Initiating order lookup for email:', email);
        lookupOrders(email);
    }
}

// Lookup orders from Shopify via Worker
async function lookupOrders(email) {
    const orderList = document.getElementById('orderList');
    const orderLoading = document.getElementById('orderLoading');
    
    orderLoading.classList.remove('hidden');
    orderList.innerHTML = '';
    
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #e53e3e;">Error: Worker URL is not configured.</div>';
            return;
        }
        
        const ordersUrl = `${workerUrl}/orders?email=${encodeURIComponent(email)}`;
        console.log('Looking up orders at:', ordersUrl);
        
        const response = await fetch(ordersUrl);
        console.log('Orders response status:', response.status);
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const orders = await response.json();
        
        if (orders.length > 0) {
            orders.forEach(order => {
                const orderItem = document.createElement('div');
                orderItem.className = 'order-item';
                orderItem.innerHTML = `
                    <strong>${order.name}</strong><br>
                    Status: ${order.status}<br>
                    Date: ${new Date(order.created_at).toLocaleDateString()}
                `;
                orderItem.dataset.order = JSON.stringify(order);
                orderItem.addEventListener('click', () => selectOrder(orderItem));
                orderList.appendChild(orderItem);
            });
        } else {
            orderList.innerHTML = '<div style="padding: 1rem; text-align: center; color: #666;">No orders found for this email.</div>';
        }
    } catch (error) {
        console.error('Error looking up orders:', error);
        orderList.innerHTML = `<div style="padding: 1rem; text-align: center; color: #e53e3e;">Failed to load orders: ${error.message}</div>`;
    } finally {
        orderLoading.classList.add('hidden');
    }
}

// Select an order
function selectOrder(orderItem) {
    // Remove selected class from all items
    document.querySelectorAll('.order-item').forEach(item => {
        item.classList.remove('selected');
    });
    
    // Add selected class to clicked item
    orderItem.classList.add('selected');
    
    // Store selected order
    selectedOrder = JSON.parse(orderItem.dataset.order);
    document.getElementById('selectedOrder').value = JSON.stringify(selectedOrder);
}

// Handle file selection
function handleFileSelect(event) {
    const files = Array.from(event.target.files);
    processFiles(files);
    event.target.value = ''; // Reset input
}

// Handle drag over
function handleDragOver(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#0070f3';
}

// Handle drop
function handleDrop(event) {
    event.preventDefault();
    event.currentTarget.style.borderColor = '#ddd';
    const files = Array.from(event.dataTransfer.files);
    processFiles(files);
}

// Process files for upload
async function processFiles(files) {
    for (const file of files) {
        // Validate file size
        if (!validateFileSize(file)) {
            alert(`${file.name} exceeds the file size limit.`);
            continue;
        }
        
        let processedFile = file;
        
        // Compress images
        if (file.type.startsWith('image/')) {
            processedFile = await compressImage(file);
        }
        
        // Upload file to R2
        const uploadUrl = await uploadFile(processedFile);
        if (uploadUrl) {
            uploadedFiles.push({
                name: file.name,
                url: uploadUrl,
                type: file.type
            });
            updateFilePreview();
        }
    }
}

// Validate file size
function validateFileSize(file) {
    if (file.type.startsWith('image/')) {
        return file.size <= 10 * 1024 * 1024; // 10MB for images
    } else if (file.type.startsWith('video/')) {
        return file.size <= 50 * 1024 * 1024; // 50MB for videos
    }
    return false;
}

// Compress image
async function compressImage(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                
                // Resize image to max 1920px width/height
                let width = img.width;
                let height = img.height;
                const maxSize = 1920;
                
                if (width > height && width > maxSize) {
                    height = Math.round((height * maxSize) / width);
                    width = maxSize;
                } else if (height > maxSize) {
                    width = Math.round((width * maxSize) / height);
                    height = maxSize;
                }
                
                canvas.width = width;
                canvas.height = height;
                
                // Draw image
                ctx.drawImage(img, 0, 0, width, height);
                
                // Convert to blob
                canvas.toBlob(
                    (blob) => {
                        resolve(new File([blob], file.name, { type: file.type }));
                    },
                    file.type,
                    0.8 // Compression quality
                );
            };
        };
    });
}

// Upload file to R2 via Worker
async function uploadFile(file) {
    try {
        // Validate workerUrl
        if (!workerUrl || workerUrl === '') {
            alert('Error: Worker URL is not configured. Please contact support.');
            return null;
        }
        
        const uploadUrl = `${workerUrl}/upload`;
        console.log('Uploading file to:', uploadUrl);
        
        const formData = new FormData();
        formData.append('file', file);
        
        const response = await fetch(uploadUrl, {
            method: 'POST',
            body: formData
        });
        
        console.log('Upload response status:', response.status);
        
        if (response.ok) {
            const data = await response.json();
            return data.url;
        } else {
            const errorText = await response.text();
            console.error('File upload error:', errorText);
            alert(`File upload failed: ${response.status} ${response.statusText}`);
            return null;
        }
    } catch (error) {
        console.error('Error uploading file:', error);
        alert(`File upload error: ${error.message}`);
        return null;
    }
}

// Update file preview
function updateFilePreview() {
    const previewContainer = document.getElementById('filePreview');
    previewContainer.innerHTML = '';
    
    uploadedFiles.forEach((file, index) => {
        const previewItem = document.createElement('div');
        previewItem.className = 'file-preview-item';
        
        if (file.type.startsWith('image/')) {
            previewItem.innerHTML = `
                <img src="${file.url}" alt="${file.name}">
                <button class="remove-btn" onclick="removeFile(${index})">×</button>
            `;
        } else if (file.type.startsWith('video/')) {
            previewItem.innerHTML = `
                <video controls>
                    <source src="${file.url}" type="${file.type}">
                </video>
                <button class="remove-btn" onclick="removeFile(${index})">×</button>
            `;
        }
        
        previewContainer.appendChild(previewItem);
    });
    
    // Update hidden input
    document.getElementById('uploadedFiles').value = JSON.stringify(uploadedFiles);
}

// Remove file from upload list
function removeFile(index) {
    uploadedFiles.splice(index, 1);
    updateFilePreview();
}

// Handle form submission
async function handleFormSubmit(event) {
    event.preventDefault();
    
    // Validate workerUrl with template syntax check
    if (!workerUrl || workerUrl === '' || workerUrl.includes('{{') || workerUrl.includes('}}')) {
        const errorMsg = 'Error: Worker URL is not configured properly. Please follow these steps:\n1. Go to Shopify Admin > Online Store > Themes > Customize\n2. Find "Shopify Ticket Form" section\n3. Enter your Cloudflare Worker URL in the "Worker URL" field\n4. Save the changes\n\nIf you need help, please contact support.';
        console.error(errorMsg);
        console.log('Current Worker URL:', workerUrl);
        alert(errorMsg);
        return;
    }
    
    const form = event.target;
    const submitBtn = document.getElementById('submitBtn');
    
    // Validate form
    if (!validateForm()) {
        return;
    }
    
    // Show loading state
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="loading"></span> Submitting...';
    
    try {
        // Create JSON payload instead of FormData
        const payload = {
            email: document.getElementById('email').value,
            phone: document.getElementById('phone').value,
            issueCategory: document.getElementById('issueCategory').value,
            issueSubcategory: document.getElementById('issueSubcategory').value,
            message: document.getElementById('message').value,
            selectedOrder: selectedOrder,
            uploadedFiles: uploadedFiles
        };
        
        // Print API URL for debugging
        const apiUrl = `${workerUrl}/ticket`;
        console.log('Submitting ticket to:', apiUrl);
        console.log('Submission payload:', payload);
        
        // Submit form with JSON
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        
        // Print response status
        console.log('Response status:', response.status);
        
        const responseData = await response.json();
        console.log('Response data:', responseData);
        
        if (response.ok) {
            console.log('Ticket submission result:', responseData);
            alert('Ticket submitted successfully!');
            form.reset();
            resetForm();
        } else {
            console.error('Error response:', responseData);
            alert(`Failed to submit ticket: ${response.status} ${responseData.error || response.statusText}`);
        }
    } catch (error) {
        console.error('Error submitting ticket:', error);
        alert(`Failed to submit ticket: ${error.message}`);
    } finally {
        // Reset button state
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Submit Ticket';
    }
}

// Validate form
function validateForm() {
    let isValid = true;
    
    // Reset errors
    document.querySelectorAll('.error-message').forEach(el => el.textContent = '');
    
    // Validate email
    const email = document.getElementById('email').value;
    if (!email) {
        document.getElementById('emailError').textContent = 'Email is required.';
        isValid = false;
    }
    
    // Validate issue type
    const category = document.getElementById('issueCategory').value;
    const subcategory = document.getElementById('issueSubcategory').value;
    if (!category || !subcategory) {
        document.getElementById('issueError').textContent = 'Please select both category and subcategory.';
        isValid = false;
    }
    
    // Validate message
    const message = document.getElementById('message').value;
    if (!message) {
        document.getElementById('messageError').textContent = 'Message is required.';
        isValid = false;
    }
    
    return isValid;
}

// Reset form state
function resetForm() {
    uploadedFiles = [];
    selectedOrder = null;
    updateFilePreview();
    document.getElementById('issueSubcategory').innerHTML = '<option value="">Select Subcategory</option>';
    document.getElementById('orderSection').style.display = 'none';
    document.getElementById('orderList').innerHTML = '';
}

// Initialize form on page load
document.addEventListener('DOMContentLoaded', initForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-countdown"] && !Shopify.designMode) return;
  try {
    
// 确保脚本在正确的位置初始化
// 这里的代码会被自动插入到页面底部

  } catch(e) { console.error(e); }
})();
})();
